/* eslint-disable max-lines */
import { createTheme } from '@mui/material';
import { useContext } from 'react';
import { h1Bold } from './variables';
import LeadGenerationContext from '../context/LeadGenerationContext';

export const LightTheme = () => {
  const leadGenerationContext = useContext(LeadGenerationContext);
  // const { productName } = leadGenerationContext;
  return createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1200,
        xl: 1536,
      },
    },
    palette: {
      primary: { main: '#000000' },
      secondary: { main: '#FFFFFF' },
      orientalPrimary: { main: '#661C69' },
      orientalSeconday: { main: '#F58220' },
      fieldsBackground: { main: '#FFFFFF' },
      fieldsBorder: { main: 'rgba(228, 233, 242, 1)' },
      plaidCardBg: { main: '#F8F8F8' },
      plaidCardBorder: { main: '#D0D0D0' },
      billTypeCustomCardbg: { main: '#F0E8F0' },
      headerBackground: { main: '#FFFFFF' },
      fieldsPlaceholder: { main: 'rgba(128, 130, 133, 1)' },
      subtext: { main: '#444444' },
      danger: { main: '#D5151F' },
      success: { main: '#E7F3E6' },
      successBackground: { main: '#E7F3E6' },
      warningBackground: { main: 'rgba(253, 247, 235, 1)' },
      errorSubtext: { main: '#313131' },
      disabled: { main: 'rgba(138, 138, 138, 1)' },
      switchOffBackground: { main: '#F3F3F3' },
      cardActiveBackground: { main: '#F0E8F0' },
      disabledAddress: { main: 'rgba(243, 243, 243, 1)' },
      iconFillerBg: { main: '#ECD0EC' },
      modalIconColor: { main: 'rgba(208, 208, 208, 1)' },
      disabledButtonBackground: { main: '#F3F3F3' },
      disabledButton: { main: '#A7A7A7' },
      mailingAddresstext: { main: '#444444' },
    },
    menuBackground: {
      backgroundColor: '#FFFFFF',
      borderColor: 'rgba(228, 233, 242, 1)',
    },
    customBackground: '#FFFFFF',
    typography: {
      button: { textTransform: 'none' },
      h1: {
        ...h1Bold,
        fontWeight: '700 !important',
        fontSize: '32px !important',
        '@media(max-width: 899px)': {
          fontSize: '1.5rem !important',
        },
      },
      h2: {
        ...h1Bold,
        fontWeight: '700 !important',
        fontSize: '28px !important',
      },
      h3: {
        ...h1Bold,
        fontWeight: '700 !important',
        fontSize: '24px !important',
      },
      h4: {
        ...h1Bold,
        fontWeight: '700 !important',
        fontSize: '22px !important',
      },
      h5: {
        ...h1Bold,
        fontSize: '20px !important',
      },
      h6: {
        ...h1Bold,
        fontSize: '18px !important',
        '@media(max-width: 899px)': {
          fontSize: '16px !important',
        },
      },
      subtitle1: {
        ...h1Bold,
        fontSize: '16px !important',
      },
      subtitle2: {
        ...h1Bold,
        fontSize: '14px !important',
      },
      body1: {
        ...h1Bold,
        fontSize: '12px',
      },
      body2: {
        ...h1Bold,
        fontSize: '11px !important',
      },
      largeHeading: {
        ...h1Bold,
        fontWeight: '700 !important',
        fontSize: '36px',
        '@media(max-width: 899px)': {
          fontSize: '2.25rem !important',
        },
      },
      mainHeading: {
        ...h1Bold,
        fontSize: '64px',
      },
      thankyouHeading: {
        ...h1Bold,
        fontSize: '48px',
      },
    },
    components: {
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            height: '2px',
            backgroundColor: ' #d0d0d0 !important',
            top: '1px',
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: '16px !important',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            fontSize: '16px !important',
          },
          root: {
            fontSize: '16px !important',
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          option: {
            fontSize: '16px !important',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            whiteSpace: 'normal',
            color: '#444444',
            fontFamily: 'Arial',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '14px',
          },
        },
      },
      MuiCalendarOrClockPicker: {
        styleOverrides: {
          root: {
            color: '#000000',
            backgroundColor: '#FFFFFF',
            borderColor: 'rgba(228, 233, 242, 1)',
            borderRadius: '8px',
            padding: '16px',
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: '#661C69',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#4a124c',
              },
            },
          },
        },
      },
      PrivatePickersMonth: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: '#661C69',
              color: '#fff',
            },
          },
        },
      },
      PrivatePickersYear: {
        styleOverrides: {
          button: {
            '&.Mui-selected': {
              backgroundColor: '#661C69 !important',
              color: '#fff',
            },
          },
        },
      },
      MuiPickersCalendarHeader: {
        styleOverrides: {
          switchViewButton: {
            color: 'rgba(0, 0, 0, 0.54)',
          },
        },
      },
      MuiPickersArrowSwitcher: {
        styleOverrides: {
          button: {
            color: 'rgba(0, 0, 0, 0.54)',
          },
        },
      },
    },
  });
};

export const DarkTheme = () => {
  const leadGenerationContext = useContext(LeadGenerationContext);
  return createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1200,
        xl: 1536,
      },
    },
    palette: {
      primary: { main: '#FFFFFF' },
      secondary: { main: '#000000' },
      orientalPrimary: { main: '#F58220' },
      orientalSeconday: { main: '#661C69' },
      fieldsBackground: { main: 'rgba(255, 255, 255, 0.1)' },
      fieldsBorder: { main: 'rgba(255, 255, 255, 0.2)' },
      plaidCardBg: { main: 'rgba(255, 255, 255, 0.1)' },
      plaidCardBorder: { main: 'rgba(255, 255, 255, 0.2)' },
      billTypeCustomCardbg: { main: 'rgba(252, 241, 232, 0.20)' },
      fieldsPlaceholder: { main: 'rgba(255, 255, 255, 0.3)' },
      headerBackground: { main: '#1F0920' },
      subtext: { main: 'rgba(255, 255, 255, 0.5)' },
      danger: { main: '#D5151F' },
      success: { main: '#0B6C03' },
      successBackground: { main: 'rgba(11, 108, 3, 0.2)' },
      warningBackground: { main: 'rgba(245, 130, 32, 0.2)' },
      errorSubtext: { main: '#FFFFFF' },
      disabled: { main: 'rgba(255, 255, 255, 0.5)' },
      switchOffBackground: { main: '#D0D0D0' },
      cardActiveBackground: { main: 'rgba(252, 241, 232, 0.2)' },
      disabledAddress: { main: 'rgba(255, 255, 255, 0.2)' },
      iconFillerBg: { main: '#FFFFFF' },
      modalIconColor: { main: 'rgba(255, 255, 255, 0.3)' },
      disabledButtonBackground: { main: 'rgba(245, 130, 32, 0.3)' },
      disabledButton: { main: 'rgba(245, 130, 32, 0.3)' },
      mailingAddresstext: { main: '#FFFFFF' },
    },
    menuBackground: {
      backgroundColor: 'rgba(63, 52, 63, 1)',
      borderColor: 'rgba(101, 92, 101, 1)',
    },
    customBackground: `linear-gradient(190.14deg, #661C69 -3.38%, #170618 47.43%, #2E0B2F 108.34%),
                       linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))`,
    typography: {
      button: { textTransform: 'none' },
      h1: {
        ...h1Bold,
        fontWeight: '700 !important',
        fontSize: '32px !important',
        '@media(max-width: 899px)': {
          fontSize: '1.5rem !important',
        },
      },
      h2: { ...h1Bold, fontWeight: '700 !important', fontSize: '28px !important' },
      h3: { ...h1Bold, fontWeight: '700 !important', fontSize: '24px !important' },
      h4: { ...h1Bold, fontWeight: '700 !important', fontSize: '22px !important' },
      h5: { ...h1Bold, fontSize: '20px !important' },
      h6: {
        ...h1Bold,
        fontSize: '18px !important',
        '@media(max-width: 899px)': {
          fontSize: '16px !important',
        },
      },
      subtitle1: { ...h1Bold, fontSize: '16px !important' },
      subtitle2: { ...h1Bold, fontSize: '14px !important' },
      body1: { ...h1Bold, fontSize: '12px' },
      body2: { ...h1Bold, fontSize: '11px !important' },
      largeHeading: {
        ...h1Bold,
        fontWeight: '700 !important',
        fontSize: '36px !important',
        '@media(max-width: 899px)': {
          fontSize: '2.25rem !important',
        },
      },
    },
    components: {
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            height: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.1) !important',
            top: '1px',
          },
        },
      },
      MuiCalendarOrClockPicker: {
        styleOverrides: {
          root: {
            color: '#FFFFFF',
            backgroundColor: 'rgba(63, 52, 63, 1)',
            borderColor: 'rgba(101, 92, 101, 1)',
            padding: '16px',
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: '16px !important',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            fontSize: '16px !important',
          },
          root: {
            fontSize: '16px !important',
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          option: {
            fontSize: '16px !important',
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            color: '#FFFFFF',
            backgroundColor: 'rgba(63, 52, 63, 1)',
            '&.Mui-selected': {
              backgroundColor: '#F58220',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#4a124c',
              },
            },
          },
        },
      },
      PrivatePickersMonth: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: '#F58220 !important',
              color: '#fff !important',
            },
          },
        },
      },
      PrivatePickersYear: {
        styleOverrides: {
          button: {
            '&.Mui-selected': {
              backgroundColor: '#F58220 !important',
              color: '#fff',
            },
          },
        },
      },
      MuiDayPicker: {
        styleOverrides: {
          weekDayLabel: {
            color: '#fff',
          },
        },
      },
      MuiPickersCalendarHeader: {
        styleOverrides: {
          switchViewButton: {
            color: '#FFFFFF',
          },
        },
      },
      MuiPickersArrowSwitcher: {
        styleOverrides: {
          button: {
            color: '#FFFFFF',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            whiteSpace: 'normal',
            color: '#FFFFFF',
            fontFamily: 'Arial',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '14px !important',
          },
        },
      },
    },
  });
};

// components: {
//   MuiSelect: {
//     styleOverrides: {
//       root: {
//         width: '100%',
//       },
//     },
//   },
//   MuiInputBase: {
//     styleOverrides: {
//       root: {
//         width: '100%',
//         height: '40px',
//       },
//     },
//   },
//   MuiTextField: {
//     styleOverrides: {
//       root: {
//         width: '100%',
//       },
//     },
//   },
//   MuiFormLabel: {
//     styleOverrides: {
//       root: {
//         width: '100%',
//         fontWeight: 600,
//         whiteSpace: 'normal',
//         '@media(max-width: 899px)': {
//           fontSize: '0.75rem',
//         },
//       },
//     },
//   },
//   MuiFormControlLabel: {
//     styleOverrides: {
//       root: {
//         width: 'max-content',
//         marginRight: '0',
//       },
//       label: {
//         // width: '100%',
//         fontWeight: '400',
//         fontSize: '14px !important',
//         whiteSpace: 'normal',
//         '@media(max-width: 899px)': {
//           fontSize: '0.75rem',
//         },
//         width: 'max-content',
//       },
//     },
//   },

//   MuiInputLabel: {
//     styleOverrides: {
//       root: {
//         whiteSpace: 'normal',
//         color: '#000',
//         fontFamily: 'Arial',
//         fontStyle: 'normal',
//         fontWeight: 700,
//         fontSize: '14px !important',
//       },
//     },
//   },
//   MuiAutocomplete: {
//     styleOverrides: {
//       input: {
//         padding: '2px 4px 7.5px 6px !important',
//       },
//     },
//   },
//   MuiButton: {
//     styleOverrides: {
//       root: {
//         fontSize: '16px',
//         minWidth: '90px',
//         height: '40px',
//         fontWeight: 700,
//       },
//     },
//   },
//   MuiAlert: {
//     styleOverrides: {
//       outlinedInfo: {
//         backgroundColor: '#F1F6FD',
//         border: 'none',
//         borderLeft: '5px solid #0052EA',
//         borderRadius: '0',
//         color: '#000000',
//       },
//     },
//   },
//   MuiLink: {
//     styleOverrides: {
//       root: {
//         '&[disabled]': {
//           color: 'grey',
//           cursor: 'default',
//           '&:hover': {
//             textDecoration: 'none',
//           },
//         },
//       },
//     },
//   },
//   MuiCheckbox: {
//     styleOverrides: {
//       root: {
//         padding: 0,
//       },
//     },
//   },
//   MuiTabs: {
//     styleOverrides: {
//       indicator: {
//         backgroundColor: '#661c69',
//       },
//     },
//   },
//   MuiTab: {
//     styleOverrides: {
//       root: {
//         color: '#661c69',
//         '&.Mui-selected': {
//           color: '#444444',
//           fontWeight: 700,
//         },
//       },
//     },
//   },
//   MuiToggleButton: {
//     styleOverrides: {
//       root: {
//         border: '1px solid #661D69',
//         borderRadius: '5px',
//         color: '#661D69',

//         '&:hover': {
//           backgroundColor: 'rgb(102, 29, 105)',
//           color: '#fff',
//         },
//         '&:focus': {
//           border: '1px solid #661D69',
//           borderRadius: '5px',
//           color: '#661D69',
//         },
//         '&.Mui-selected': {
//           backgroundColor: 'rgb(102, 29, 105)',
//           color: '#fff',
//           '&:hover': {
//             backgroundColor: 'rgb(102, 29, 105)',
//             color: '#fff',
//           },
//         },
//         '&.Mui-disabled': {
//           border: '1px solid #661D69',
//           color: '#661D69',
//           opacity: 0.4,
//         },
//       },
//     },
//   },
//   MuiToggleButtonGroup: {
//     styleOverrides: {
//       root: {
//         alignItems: 'center',
//       },
//       grouped: {
//         maxHeight: '40px',

//         '&:disabled': {
//           border: '1px solid #661D69',
//           opacity: 0.4,
//         },
//       },
//     },
//   },

//   MuiListItemButton: {
//     styleOverrides: {
//       root: {
//         '&.Mui-selected': {
//           backgroundColor: 'rgba(255,255,255,.1)',
//           borderLeft: '5px solid #fff',
//         },
//       },
//     },
//   },

//   MuiTableHead: {
//     styleOverrides: {
//       root: {
//         backgroundColor: '#FFD68A',
//         fontWeight: 600,
//       },
//     },
//   },
// },
